// images
import blogImg1 from "../images/blogs/blog_post_image_1.webp";
import blogImg2 from "../images/blogs/blog_post_image_2.webp";
import blogImg3 from "../images/blogs/blog_post_image_3.webp";
import blogImg4 from "../images/blogs/blog_post_image_4.webp";
import blogImg5 from "../images/blogs/blog_post_image_5.webp";
import blogImg6 from "../images/blogs/blog_post_image_6.webp";


const blogs = [
    {
        id: '1',
        title: 'How Our Unique Tokenomics Ensures Sustainable Growth and Value?',
        slug:'How-Our-Unique-Tokenomics-Ensures-Sustainable-Growth-and-Value',
        screens: blogImg1,
        description: 'Ethereum is the ideal blockchain for ICOs due to its secure smart contracts and decentralization. It enables transparent, direct fundraising from global.',
        author: 'farugia',
        authorTitle:'Sineor Consultant',
        create_at: 'October 4, 2025',
        comment:'35',
        thumb:'# TUCK Blog',
        blClass:'format-standard-image',
    },
    {
        id: '2',
        title: 'Why Ethereum is the Ideal Blockchain Platform for Successful ICO..',
        slug:'Why-Ethereum-is-the-Ideal-Blockchain-Platform-for-Successful-ICO..',
        screens: blogImg2,
        description: 'Ethereum is the ideal blockchain for ICOs due to its secure smart contracts and decentralization. It enables transparent, direct fundraising from global.',
        author: 'Andrew',
        authorTitle:'Creative Director',
        create_at: 'October 4, 2023',
        comment:'80',
        thumb:'# TUCK Blog',
        blClass:'format-standard-image',
    },
    {
        id: '3',
        title: 'What Makes ICOs a Game-Changer for Bitcoin and Crypto Investors?..',
        slug: 'What-Makes-ICOs-a-Game-Changer-for-Bitcoin-and-Crypto-Investors?..',
        screens: blogImg3,
        description: 'Our ICO pioneers blockchain innovation, shaping the future.',
        author: 'Kurtz',
        authorTitle:'Art Director',
        create_at: 'October 4, 2024',
        comment:'95',
        thumb:'# TUCK Blog',
        blClass:'format-video',
    },
    {
        id: '4',
        title: 'Behind the Scenes of Our ICO Insights into Project..',
        slug: 'Behind-the-Scenes-of-Our-ICO-Insights-into-Project..',
        screens: blogImg4,
        description: 'Our ICO focuses on strategic planning, partnerships.',
        author: 'Alex',
        authorTitle:'Art Director',
        create_at: 'October 5, 2023',
        comment:'95',
        thumb:'# TUCK Blog',
    },
    {
        id: '5',
        title: 'Our Vision for a Blockchain-Powered Future and How You Can Join Us..',
        slug: 'Our-Vision-for-a-Blockchain-Powered-Future-and-How-You-Can-Join-Us',
        screens: blogImg5,
        description: 'The future of cybersecurity relies on innovative IT.',
        author: 'Aliza',
        authorTitle:'Art Director',
        create_at: 'October 6, 2025',
        comment:'95',
        thumb:'# TUCK Blog',
    },
    {
        id: '6',
        title: 'How We Ensure Security and Protect Your Investment in Our ICO..',
        slug: 'How-We-Ensure-Security-and-Protect-Your-Investment-in-Our-ICO..',
        screens: blogImg6,
        description: 'The future of cybersecurity relies on innovative IT.',
        author: 'Aliza',
        authorTitle:'Art Director',
        create_at: 'October 6, 2025',
        comment:'95',
        thumb:'# TUCK Blog',
    }
];
export default blogs;